import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock-upgrade';
import { computePosition } from '@floating-ui/dom';
import { autoUpdate, offset } from '@floating-ui/dom';

export function topbar() {
  const topbar = document.querySelector('.topbar');
  if (!topbar) return;

  // menu
  const hamburger = topbar.querySelector('.topbar__hamburger');
  const openMenu = () => {
    topbar.classList.add('is-menu-opened');
    hamburger.classList.add('is-active');
    disableBodyScroll(topbar);
  };
  const closeMenu = () => {
    topbar.classList.add('is-menu-closed');
    topbar.classList.remove('is-menu-opened');
    hamburger.classList.remove('is-active');
    enableBodyScroll(topbar);
  };
  const isMenuOpened = () => topbar.classList.contains('is-menu-opened');
  const toggleMenu = () => {
    if (isMenuOpened()) closeMenu();
    else openMenu();
  };
  hamburger.addEventListener('click', toggleMenu);

  // search popup
  const searchForm = topbar.querySelector('.topbar__search');
  const searchButton = topbar.querySelector('.topbar__search-button');
  const searchInput = searchForm.querySelector('.search-form__input');

  let autoUpdateCleanup;
  const isSearchOpened = () => searchButton.classList.contains('is-active');
  const openSearch = () => {
    searchButton.classList.add('is-active');
    searchForm.classList.add('is-active');
    searchInput.focus();

    autoUpdateCleanup = autoUpdate(searchButton, searchForm, () => {
      computePosition(searchButton, searchForm, {
        placement: 'bottom-start',
        middleware: [offset(12)],
      }).then(({ x, y }) => {
        Object.assign(searchForm.style, { top: `${y}px`, left: `${x}px` });
      });
    });
  };
  const closeSearch = () => {
    searchButton.classList.remove('is-active');
    searchForm.classList.remove('is-active');
    if (autoUpdateCleanup) autoUpdateCleanup();
    searchForm.removeAttribute('style');
  };
  const toggleSearch = () => {
    if (isSearchOpened()) closeSearch();
    else openSearch();
  };

  searchButton.addEventListener('click', toggleSearch);

  const media = window.matchMedia('(max-width: 1399px)');
  searchInput.addEventListener('blur', closeSearch);

  try {
    media.addEventListener('change', closeSearch);
  } catch (e) {
    media.addListener(closeSearch);
  }
}
